import AiOperationsPage from '../components/analytics/aiOperations/AiOperationsPage';

const AiOperationsAnalyticsPage = () => <AiOperationsPage />;

export default AiOperationsAnalyticsPage;
